import React, { useEffect, useState } from 'react'
import translate from '../../../../../i18n/translate'
import { ReactComponent as AudioBtn } from '../../../../../assets/img/metaberry_ui/sound_on.svg'
import { getCurrentLangString } from '../../../../../i18n/initI18n'
import useSound from '../../../../views/MetaberryView/hooks/useSound'
import { getSoundAssistance } from '../../../../../services/settingsService'
import { Analysis } from '../../../../../services/analysisService'

const OnboardingIntroductionPanel1 = ({ handleButton, pathSchool }) => {
  const { renderSoundFXController, playSoundEffect } = useSound()
  const langCode = getCurrentLangString()
  const audioFile = 'intro01_' + langCode
  const audioFileHumansCartoons = 'intro01_' + langCode + '_humans_cartoons'
  const [blueberroImage, setBlueberroImage] = useState('')
  const [blueberroMobileImage, setBlueberroMobileImage] = useState('')
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 520)

  useEffect(() => {
    getSoundAssistance() &&
      playSoundEffect(pathSchool ? audioFileHumansCartoons : audioFile)

    // Set initial images
    updateImages()

    // Add window resize listener
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768)
    }

    window.addEventListener('resize', handleResize)

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [pathSchool])

  const updateImages = () => {
    const baseDesktopPath = pathSchool
      ? `/assets/graphics/gamification/${pathSchool}/bb_astronaut_idle.svg`
      : `/assets/graphics/gamification/bb_intro_hello.svg`

    const baseMobilePath = pathSchool
      ? `/assets/graphics/gamification/${pathSchool}/bb_idle.png`
      : `/assets/graphics/gamification/blueberro_hint.svg`

    setBlueberroImage(baseDesktopPath)
    setBlueberroMobileImage(baseMobilePath)
  }

  const handleAudio = () => {
    Analysis.sendEvent(Analysis.EVENT.REQUEST_TEXT_TO_SPEECH, {
      type: 'onboarding'
    })

    Analysis.sendSegmentTrackEvent(Analysis.SEGMENT_EVENTS['TTS Clicked'], {
      object: 'onboarding',
      ui_element_id: 'onboarding_introduction_1',
      seed_id: undefined
    })
    playSoundEffect(pathSchool ? audioFileHumansCartoons : audioFile)
  }

  return (
    <div className="onboarding-panel--intro onboarding-white-design">
      <div className="onboarding-panel__bb-image_new-popup">
        {isDesktop ? (
          <img
            src={blueberroImage}
            alt=""
            className="onboarding-blueberro-desktop-image"
          />
        ) : (
          <img
            src={blueberroMobileImage}
            alt=""
            className={
              pathSchool
                ? 'onboarding-humans-cartoons-mobile-image'
                : 'onboarding-blueberro-mobile-image'
            }
          />
        )}
      </div>
      <div className="onboarding-panel_text-container">
        {renderSoundFXController()}
        <AudioBtn className="onboarding-panel__audio" onClick={handleAudio} />
        {!pathSchool ? (
          <div
            className="onboarding-panel__text-title"
            dangerouslySetInnerHTML={{
              __html: translate('onboarding_intro_text_1')
            }}
          ></div>
        ) : (
          <div
            className="onboarding-panel__text-title"
            dangerouslySetInnerHTML={{
              __html: translate('onboarding_intro_text_1_humans')
            }}
          ></div>
        )}
        <div
          className="onboarding-panel__button-purple-design"
          onClick={handleButton}
          data-testid="onboarding_intro_button_1"
        >
          {translate('onboarding_intro_button_1')}
        </div>
      </div>
    </div>
  )
}

export default OnboardingIntroductionPanel1
